module.exports = __webpack_public_path__ + "weathericons-regular-webfont.ecaf8b481729b18f6a84.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/weathericons-regular-webfont.svg
// module id = 982
// module chunks = 2